export default __webpack_public_path__ + "ae5107cbda0e85a55a67310f4cbd8ef2.jpg";